<template>

  <div class="container-fluid-lg" v-if="loaded">
    <div
      v-masonry="masonry" item-selector=".cols" transition-duration="0"
      class="row g-sm-4 g-3 row-cols-xxl-4 row-cols-xl-4 row-cols-lg-2 row-cols-md-4 row-cols-2 product-list-section masonry-container"
      id="masonry">
      <div v-for="(listing, index) in listings" class="cols" v-masonry-tile>
        <div class="product-box-3 wow fadeInUp">
          <div class="product-header">
            <div class="product-image">
              <router-link
                :to="listing?.link">
                <img :src="listing?.images?.[0]?.image_url"
                     class="img-fluid lazyload" :alt="listing?.name + ' image sokoni'">
              </router-link>
            </div>
          </div>
          <div class="product-footer">
            <div class="product-detail">
              <span class="span-name">
                  {{ listing?.category?.name }}
              </span>
              <router-link
                :title="listing?.name + 'in Kenya'"
                :to="listing?.link">
                <h2 class="name" style="font-size: 16px">
                  {{ listing?.name }}
                </h2>
              </router-link>
              <p class="text-content mt-1 mb-2 text-ellipsis">
                {{ stripHTML(listing?.description) }}
              </p>
              <h6 class="unit">
                {{ listing?.location?.name }}
              </h6>
              <h5 class="price">
                <span class="theme-color">
                    {{ (listing?.currency_price) }}
                </span>
              </h5>
              <div class="add-to-cart-box bg-white"></div>
            </div>
          </div>
        </div>
        <div v-if="index % 5 === 0 && show_ads"
             class="d-none d-md-block product-box-3 wow fadeInUp adsense-ad-desktop">
          <AdsenseComponentDesktop />
        </div>
        <div v-if="index % 5 === 0"
             class="d-block d-md-none product-box-3 wow fadeInUp adsense-ad-mobile">
          <AdsenseComponentMobile />
        </div>
      </div>
    </div>
    <div class="loader" v-loading="loading"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GeneralController from '@/mixins/GeneralController'
import AdsenseComponentMobile from '@/components/AdsenseComponentMobile.vue'
import AdsenseComponentDesktop from '@/components/AdsenseComponentDesktop.vue'

export default {
  name: 'SimilarListings',
  data() {
    return {
      loaded: false,
      show_ads: false,
      filters: {
        page: 1,
        paginate: true,
        similar: true
      }
    }
  },
  components: { AdsenseComponentDesktop, AdsenseComponentMobile },
  mixins: [GeneralController],
  props: {
    listing_id: {
      required: true
    }
  },
  computed: {
    ...mapGetters({
      'listings': 'listings/listings',
      'last_page': 'listings/last_page',
      'loading': 'listings/loading'
    })
  },
  methods: {
    ...mapActions({
      'getListings': 'listings/getListings',
      'getListingsScroll': 'listings/getListingsScroll'
    })
  },

  mounted() {
    this.scrollTop()
    this.filters.listing_id = this.listing_id
    this.getListings({
      ...this.filters,
      reset: true
    }).then(() => {
      this.loaded = true
    })
    window.onscroll = () => {
      if (this.$route.path.includes('/listings/')) {
        let bottomOfWindow = (document.documentElement.scrollHeight - document.documentElement.scrollTop) - document.documentElement.clientHeight <= 500
        if (!this.loading && Number(this.filters.page) + 1 <= Number(this.last_page)) {
          if (bottomOfWindow) {
            this.show_ads = true
            this.filters.page += 1
            this.getListingsScroll(this.filters)
          }
        }
      }
    }
  }
}
</script>
